import { render, staticRenderFns } from "./menu2.vue?vue&type=template&id=065bf211&scoped=true"
import script from "./menu2.vue?vue&type=script&lang=js"
export * from "./menu2.vue?vue&type=script&lang=js"
import style0 from "./menu2.vue?vue&type=style&index=0&id=065bf211&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065bf211",
  null
  
)

export default component.exports